import { render, staticRenderFns } from "./WPTitle.vue?vue&type=template&id=1f5c9418"
import script from "./WPTitle.vue?vue&type=script&lang=ts"
export * from "./WPTitle.vue?vue&type=script&lang=ts"
import style0 from "./WPTitle.vue?vue&type=style&index=0&id=1f5c9418&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports